// const moduleB = () => {
//   console.log("component other");
// };
import { Component, EventBus } from '../core/smpl-components.js'
import ExternalSources from '../modules/external-sources.js'

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {}
	mount() {
		this.externalVideo = new ExternalSources(this.element)
	}
	unmount() {
		if (this.externalVideo) {
			this.externalVideo.destroy()
		}
	}

	// Force a source re-pick now rather than on the next debounced resize. Needed
	// when the video is revealed from display:none — at mount its clientWidth was
	// 0, so it settled on the smallest file.
	updateSource() {
		if (this.externalVideo) {
			this.externalVideo.updateSource()
		}
	}
}
